// 由 lingzhi-design 生成，不要手改。来源：lingzhi.resolver.json。
// 用法：<ConfigProvider theme={{ ...getLingzhiAntdTheme('dark'), algorithm: theme.darkAlgorithm }}>（浅色不用 algorithm）。

export const appearances = ["light-ink","light","light-paper","light-bright","dark"]

export const lingzhiAntdThemes = {
  "light-ink": {
    "token": {
      "colorPrimary": "#1c1b19",
      "colorPrimaryHover": "#3a3833",
      "colorPrimaryActive": "#1c1b19",
      "colorPrimaryBg": "#ebe9e4",
      "colorPrimaryBgHover": "rgba(28, 27, 25, 0.078)",
      "colorPrimaryBorder": "#1c1b19",
      "colorPrimaryBorderHover": "#3a3833",
      "colorPrimaryText": "#1c1b19",
      "colorPrimaryTextHover": "#1c1b19",
      "colorPrimaryTextActive": "#1c1b19",
      "colorLink": "#1c1b19",
      "colorLinkHover": "#57554f",
      "colorLinkActive": "#1c1b19",
      "colorSuccess": "#16732a",
      "colorSuccessBg": "rgba(40, 205, 65, 0.122)",
      "colorWarning": "#7a4f00",
      "colorWarningBg": "rgba(122, 79, 0, 0.078)",
      "colorError": "#a21f18",
      "colorErrorHover": "#861812",
      "colorErrorActive": "#861812",
      "colorErrorBg": "rgba(162, 31, 24, 0.078)",
      "colorInfo": "#5468e0",
      "colorTextBase": "#1c1b19",
      "colorBgBase": "#faf9f7",
      "colorText": "#1c1b19",
      "colorTextSecondary": "#57554f",
      "colorTextTertiary": "#66635d",
      "colorTextQuaternary": "#8a8780",
      "colorTextPlaceholder": "#66635d",
      "colorTextDisabled": "#8a8780",
      "colorIcon": "#8a8780",
      "colorIconHover": "#57554f",
      "colorBgLayout": "#faf9f7",
      "colorBgContainer": "#ffffff",
      "colorBgElevated": "#ffffff",
      "colorBgSpotlight": "#1c1b19",
      "colorBgMask": "rgba(28, 27, 25, 0.161)",
      "colorBorder": "rgba(28, 27, 25, 0.078)",
      "colorBorderSecondary": "rgba(28, 27, 25, 0.071)",
      "colorSplit": "rgba(28, 27, 25, 0.071)",
      "colorFill": "rgba(28, 27, 25, 0.078)",
      "colorFillSecondary": "rgba(28, 27, 25, 0.051)",
      "colorFillTertiary": "rgba(28, 27, 25, 0.039)",
      "colorFillQuaternary": "rgba(28, 27, 25, 0.039)",
      "controlItemBgHover": "rgba(28, 27, 25, 0.039)",
      "controlItemBgActive": "#ebe9e4",
      "controlItemBgActiveHover": "#ebe9e4",
      "colorBgContainerDisabled": "rgba(28, 27, 25, 0.039)",
      "controlOutline": "rgba(28, 27, 25, 0.6)",
      "controlOutlineWidth": 2,
      "lineWidthFocus": 2,
      "fontFamily": "-apple-system, BlinkMacSystemFont, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Segoe UI', sans-serif",
      "fontFamilyCode": "'SF Mono', 'JetBrains Mono', Menlo, Consolas, monospace",
      "fontSize": 14.5,
      "fontSizeSM": 12.5,
      "fontSizeLG": 15.5,
      "fontSizeHeading1": 28,
      "fontSizeHeading2": 24,
      "fontSizeHeading3": 21,
      "fontSizeHeading4": 15.5,
      "fontSizeHeading5": 14.5,
      "lineHeight": 1.6,
      "fontWeightStrong": 600,
      "borderRadius": 14,
      "borderRadiusLG": 20,
      "borderRadiusSM": 13,
      "borderRadiusXS": 9,
      "borderRadiusOuter": 14,
      "controlHeight": 34,
      "controlHeightSM": 30,
      "controlHeightLG": 46,
      "controlHeightXS": 22,
      "motionDurationFast": "0.16s",
      "motionDurationMid": "0.22s",
      "motionDurationSlow": "0.32s",
      "motionEaseOut": "cubic-bezier(0.23, 1, 0.32, 1)",
      "motionEaseInOut": "cubic-bezier(0.32, 0.72, 0, 1)",
      "motionEaseOutBack": "cubic-bezier(0.34, 1.36, 0.64, 1)",
      "boxShadow": "0px 0px 0px 1px rgba(0, 0, 0, 0.05), 0px 8px 20px -6px rgba(0, 0, 0, 0.078), 0px 28px 60px -18px rgba(0, 0, 0, 0.2)",
      "boxShadowSecondary": "0px 0px 0px 1px rgba(0, 0, 0, 0.04), 0px 4px 12px -4px rgba(0, 0, 0, 0.071), 0px 18px 40px -14px rgba(0, 0, 0, 0.141)",
      "boxShadowTertiary": "0px 0px 0px 1px rgba(0, 0, 0, 0.04), 0px 1px 3px 0px rgba(0, 0, 0, 0.078)",
      "wireframe": false
    },
    "components": {
      "Button": {
        "colorPrimary": "#1c1b19",
        "colorPrimaryHover": "#3a3833",
        "colorPrimaryActive": "#1c1b19",
        "primaryColor": "#ffffff",
        "primaryShadow": "0px 0px 0px 1px rgba(0, 0, 0, 0.063)",
        "defaultBg": "rgba(28, 27, 25, 0.051)",
        "defaultColor": "#57554f",
        "defaultBorderColor": "transparent",
        "defaultHoverBg": "rgba(28, 27, 25, 0.09)",
        "defaultHoverColor": "#1c1b19",
        "defaultHoverBorderColor": "transparent",
        "defaultActiveBg": "rgba(28, 27, 25, 0.12)",
        "defaultActiveColor": "#1c1b19",
        "defaultActiveBorderColor": "transparent",
        "defaultShadow": "none",
        "textHoverBg": "rgba(28, 27, 25, 0.051)",
        "colorError": "#a21f18",
        "colorErrorHover": "#861812",
        "colorErrorActive": "#861812",
        "dangerColor": "#ffffff",
        "borderRadius": 999,
        "borderRadiusLG": 999,
        "borderRadiusSM": 999,
        "controlHeight": 34,
        "controlHeightSM": 30,
        "controlHeightLG": 46,
        "paddingInline": 16,
        "paddingInlineSM": 12,
        "fontWeight": 500,
        "contentFontSize": 13.5
      },
      "Card": {
        "colorBgContainer": "#ffffff",
        "colorBorderSecondary": "transparent",
        "borderRadiusLG": 20,
        "bodyPadding": 16,
        "headerBg": "transparent",
        "boxShadowTertiary": "0px 0px 0px 1px rgba(0, 0, 0, 0.04), 0px 4px 12px -4px rgba(0, 0, 0, 0.071), 0px 18px 40px -14px rgba(0, 0, 0, 0.141)"
      },
      "Menu": {
        "itemBg": "transparent",
        "subMenuItemBg": "transparent",
        "itemColor": "#57554f",
        "itemHoverColor": "#1c1b19",
        "itemHoverBg": "rgba(28, 27, 25, 0.051)",
        "itemActiveBg": "rgba(28, 27, 25, 0.12)",
        "itemSelectedBg": "#ebe9e4",
        "itemSelectedColor": "#1c1b19",
        "itemBorderRadius": 14,
        "itemHeight": 38,
        "activeBarBorderWidth": 0,
        "activeBarWidth": 0
      },
      "Segmented": {
        "trackBg": "rgba(28, 27, 25, 0.039)",
        "trackPadding": 4,
        "itemColor": "#57554f",
        "itemHoverColor": "#1c1b19",
        "itemHoverBg": "transparent",
        "itemActiveBg": "transparent",
        "itemSelectedBg": "#ffffff",
        "itemSelectedColor": "#1c1b19",
        "boxShadowTertiary": "0px 0px 0px 1px rgba(0, 0, 0, 0.04), 0px 1px 3px 0px rgba(0, 0, 0, 0.078)",
        "borderRadius": 999,
        "borderRadiusSM": 999,
        "borderRadiusLG": 999,
        "controlHeight": 32
      },
      "Input": {
        "colorBgContainer": "rgba(28, 27, 25, 0.039)",
        "colorBorder": "transparent",
        "hoverBorderColor": "transparent",
        "activeBorderColor": "transparent",
        "activeShadow": "0 0 0 2px rgba(28, 27, 25, 0.6)",
        "colorTextPlaceholder": "#66635d",
        "borderRadius": 999,
        "borderRadiusSM": 999,
        "borderRadiusLG": 999,
        "paddingInline": 16,
        "controlHeightLG": 46
      },
      "Tag": {
        "defaultBg": "rgba(28, 27, 25, 0.039)",
        "defaultColor": "#66635d",
        "borderRadiusSM": 999
      },
      "Modal": {
        "contentBg": "#ffffff",
        "headerBg": "#ffffff",
        "footerBg": "transparent",
        "borderRadiusLG": 28,
        "boxShadow": "0px 0px 0px 1px rgba(0, 0, 0, 0.05), 0px 8px 20px -6px rgba(0, 0, 0, 0.078), 0px 28px 60px -18px rgba(0, 0, 0, 0.2)"
      },
      "Drawer": {
        "colorBgElevated": "#ffffff",
        "colorBgMask": "rgba(28, 27, 25, 0.161)"
      },
      "Dropdown": {
        "colorBgElevated": "#ffffff",
        "borderRadiusLG": 22,
        "borderRadiusSM": 14,
        "boxShadowSecondary": "0px 0px 0px 1px rgba(0, 0, 0, 0.05), 0px 8px 20px -6px rgba(0, 0, 0, 0.078), 0px 28px 60px -18px rgba(0, 0, 0, 0.2)",
        "controlItemBgHover": "rgba(28, 27, 25, 0.039)",
        "controlHeight": 38
      },
      "Tooltip": {
        "colorBgSpotlight": "#1c1b19",
        "colorTextLightSolid": "#faf9f7",
        "borderRadius": 14
      },
      "Layout": {
        "bodyBg": "#faf9f7",
        "headerBg": "#faf9f7",
        "siderBg": "#f3f2ef",
        "lightSiderBg": "#f3f2ef"
      },
      "Checkbox": {
        "colorPrimary": "#1c1b19",
        "colorPrimaryHover": "#1c1b19",
        "colorWhite": "#ffffff"
      },
      "Radio": {
        "colorPrimary": "#1c1b19",
        "buttonSolidCheckedBg": "#1c1b19",
        "buttonSolidCheckedColor": "#ffffff",
        "buttonSolidCheckedHoverBg": "#3a3833",
        "buttonSolidCheckedActiveBg": "#3a3833"
      },
      "Switch": {
        "colorPrimary": "#1c1b19",
        "colorPrimaryHover": "#1c1b19"
      },
      "Message": {
        "contentBg": "#ffffff"
      },
      "Notification": {
        "colorBgElevated": "#ffffff"
      }
    }
  },
  "light": {
    "token": {
      "colorPrimary": "#ffe169",
      "colorPrimaryHover": "#ffd84a",
      "colorPrimaryActive": "#ffcf1a",
      "colorPrimaryBg": "#fff7d6",
      "colorPrimaryBgHover": "rgba(0, 0, 0, 0.078)",
      "colorPrimaryBorder": "#ffe169",
      "colorPrimaryBorderHover": "#ffd84a",
      "colorPrimaryText": "#262626",
      "colorPrimaryTextHover": "#262626",
      "colorPrimaryTextActive": "#262626",
      "colorLink": "#262626",
      "colorLinkHover": "#646464",
      "colorLinkActive": "#262626",
      "colorSuccess": "#16732a",
      "colorSuccessBg": "rgba(40, 205, 65, 0.122)",
      "colorWarning": "#7a4f00",
      "colorWarningBg": "rgba(122, 79, 0, 0.078)",
      "colorError": "#a21f18",
      "colorErrorHover": "#861812",
      "colorErrorActive": "#861812",
      "colorErrorBg": "rgba(162, 31, 24, 0.078)",
      "colorInfo": "#5468e0",
      "colorTextBase": "#262626",
      "colorBgBase": "#ffffff",
      "colorText": "#262626",
      "colorTextSecondary": "#646464",
      "colorTextTertiary": "#696969",
      "colorTextQuaternary": "#8d8d8d",
      "colorTextPlaceholder": "#696969",
      "colorTextDisabled": "#8d8d8d",
      "colorIcon": "#8d8d8d",
      "colorIconHover": "#646464",
      "colorBgLayout": "#ffffff",
      "colorBgContainer": "#ffffff",
      "colorBgElevated": "#ffffff",
      "colorBgSpotlight": "#333333",
      "colorBgMask": "rgba(0, 0, 0, 0.12)",
      "colorBorder": "rgba(0, 0, 0, 0.078)",
      "colorBorderSecondary": "rgba(0, 0, 0, 0.05)",
      "colorSplit": "rgba(0, 0, 0, 0.05)",
      "colorFill": "rgba(0, 0, 0, 0.078)",
      "colorFillSecondary": "rgba(0, 0, 0, 0.059)",
      "colorFillTertiary": "rgba(0, 0, 0, 0.043)",
      "colorFillQuaternary": "rgba(0, 0, 0, 0.043)",
      "controlItemBgHover": "rgba(0, 0, 0, 0.043)",
      "controlItemBgActive": "#fff7d6",
      "controlItemBgActiveHover": "#fff7d6",
      "colorBgContainerDisabled": "rgba(0, 0, 0, 0.043)",
      "controlOutline": "rgba(38, 38, 38, 0.6)",
      "controlOutlineWidth": 2,
      "lineWidthFocus": 2,
      "fontFamily": "-apple-system, BlinkMacSystemFont, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Segoe UI', sans-serif",
      "fontFamilyCode": "'SF Mono', 'JetBrains Mono', Menlo, Consolas, monospace",
      "fontSize": 14.5,
      "fontSizeSM": 12.5,
      "fontSizeLG": 15.5,
      "fontSizeHeading1": 28,
      "fontSizeHeading2": 24,
      "fontSizeHeading3": 21,
      "fontSizeHeading4": 15.5,
      "fontSizeHeading5": 14.5,
      "lineHeight": 1.6,
      "fontWeightStrong": 600,
      "borderRadius": 14,
      "borderRadiusLG": 20,
      "borderRadiusSM": 13,
      "borderRadiusXS": 9,
      "borderRadiusOuter": 14,
      "controlHeight": 34,
      "controlHeightSM": 30,
      "controlHeightLG": 46,
      "controlHeightXS": 22,
      "motionDurationFast": "0.16s",
      "motionDurationMid": "0.22s",
      "motionDurationSlow": "0.32s",
      "motionEaseOut": "cubic-bezier(0.23, 1, 0.32, 1)",
      "motionEaseInOut": "cubic-bezier(0.32, 0.72, 0, 1)",
      "motionEaseOutBack": "cubic-bezier(0.34, 1.36, 0.64, 1)",
      "boxShadow": "0px 0px 0px 1px rgba(0, 0, 0, 0.05), 0px 8px 20px -6px rgba(0, 0, 0, 0.078), 0px 28px 60px -18px rgba(0, 0, 0, 0.2)",
      "boxShadowSecondary": "0px 0px 0px 1px rgba(0, 0, 0, 0.04), 0px 4px 12px -4px rgba(0, 0, 0, 0.071), 0px 18px 40px -14px rgba(0, 0, 0, 0.141)",
      "boxShadowTertiary": "0px 0px 0px 1px rgba(0, 0, 0, 0.04), 0px 1px 3px 0px rgba(0, 0, 0, 0.078)",
      "wireframe": false
    },
    "components": {
      "Button": {
        "colorPrimary": "#ffe169",
        "colorPrimaryHover": "#ffd84a",
        "colorPrimaryActive": "#ffcf1a",
        "primaryColor": "#262626",
        "primaryShadow": "0px 0px 0px 1px rgba(0, 0, 0, 0.063)",
        "defaultBg": "rgba(0, 0, 0, 0.059)",
        "defaultColor": "#646464",
        "defaultBorderColor": "transparent",
        "defaultHoverBg": "rgba(0, 0, 0, 0.09)",
        "defaultHoverColor": "#262626",
        "defaultHoverBorderColor": "transparent",
        "defaultActiveBg": "rgba(0, 0, 0, 0.12)",
        "defaultActiveColor": "#262626",
        "defaultActiveBorderColor": "transparent",
        "defaultShadow": "none",
        "textHoverBg": "rgba(0, 0, 0, 0.059)",
        "colorError": "#a21f18",
        "colorErrorHover": "#861812",
        "colorErrorActive": "#861812",
        "dangerColor": "#ffffff",
        "borderRadius": 999,
        "borderRadiusLG": 999,
        "borderRadiusSM": 999,
        "controlHeight": 34,
        "controlHeightSM": 30,
        "controlHeightLG": 46,
        "paddingInline": 16,
        "paddingInlineSM": 12,
        "fontWeight": 500,
        "contentFontSize": 13.5
      },
      "Card": {
        "colorBgContainer": "#f5f5f5",
        "colorBorderSecondary": "transparent",
        "borderRadiusLG": 20,
        "bodyPadding": 16,
        "headerBg": "transparent",
        "boxShadowTertiary": "0px 0px 0px 1px rgba(0, 0, 0, 0.04), 0px 4px 12px -4px rgba(0, 0, 0, 0.071), 0px 18px 40px -14px rgba(0, 0, 0, 0.141)"
      },
      "Menu": {
        "itemBg": "transparent",
        "subMenuItemBg": "transparent",
        "itemColor": "#646464",
        "itemHoverColor": "#262626",
        "itemHoverBg": "rgba(0, 0, 0, 0.059)",
        "itemActiveBg": "rgba(0, 0, 0, 0.12)",
        "itemSelectedBg": "#fff7d6",
        "itemSelectedColor": "#262626",
        "itemBorderRadius": 14,
        "itemHeight": 38,
        "activeBarBorderWidth": 0,
        "activeBarWidth": 0
      },
      "Segmented": {
        "trackBg": "rgba(0, 0, 0, 0.043)",
        "trackPadding": 4,
        "itemColor": "#646464",
        "itemHoverColor": "#262626",
        "itemHoverBg": "transparent",
        "itemActiveBg": "transparent",
        "itemSelectedBg": "#ffffff",
        "itemSelectedColor": "#262626",
        "boxShadowTertiary": "0px 0px 0px 1px rgba(0, 0, 0, 0.04), 0px 1px 3px 0px rgba(0, 0, 0, 0.078)",
        "borderRadius": 999,
        "borderRadiusSM": 999,
        "borderRadiusLG": 999,
        "controlHeight": 32
      },
      "Input": {
        "colorBgContainer": "rgba(0, 0, 0, 0.043)",
        "colorBorder": "transparent",
        "hoverBorderColor": "transparent",
        "activeBorderColor": "transparent",
        "activeShadow": "0 0 0 2px rgba(38, 38, 38, 0.6)",
        "colorTextPlaceholder": "#696969",
        "borderRadius": 999,
        "borderRadiusSM": 999,
        "borderRadiusLG": 999,
        "paddingInline": 16,
        "controlHeightLG": 46
      },
      "Tag": {
        "defaultBg": "rgba(0, 0, 0, 0.043)",
        "defaultColor": "#696969",
        "borderRadiusSM": 999
      },
      "Modal": {
        "contentBg": "#ffffff",
        "headerBg": "#ffffff",
        "footerBg": "transparent",
        "borderRadiusLG": 28,
        "boxShadow": "0px 0px 0px 1px rgba(0, 0, 0, 0.05), 0px 8px 20px -6px rgba(0, 0, 0, 0.078), 0px 28px 60px -18px rgba(0, 0, 0, 0.2)"
      },
      "Drawer": {
        "colorBgElevated": "#ffffff",
        "colorBgMask": "rgba(0, 0, 0, 0.12)"
      },
      "Dropdown": {
        "colorBgElevated": "#ffffff",
        "borderRadiusLG": 22,
        "borderRadiusSM": 14,
        "boxShadowSecondary": "0px 0px 0px 1px rgba(0, 0, 0, 0.05), 0px 8px 20px -6px rgba(0, 0, 0, 0.078), 0px 28px 60px -18px rgba(0, 0, 0, 0.2)",
        "controlItemBgHover": "rgba(0, 0, 0, 0.043)",
        "controlHeight": 38
      },
      "Tooltip": {
        "colorBgSpotlight": "#333333",
        "colorTextLightSolid": "#fafafa",
        "borderRadius": 14
      },
      "Layout": {
        "bodyBg": "#ffffff",
        "headerBg": "#ffffff",
        "siderBg": "#fafafa",
        "lightSiderBg": "#fafafa"
      },
      "Checkbox": {
        "colorPrimary": "#8f6c00",
        "colorPrimaryHover": "#8f6c00",
        "colorWhite": "#ffffff"
      },
      "Radio": {
        "colorPrimary": "#8f6c00",
        "buttonSolidCheckedBg": "#ffe169",
        "buttonSolidCheckedColor": "#262626",
        "buttonSolidCheckedHoverBg": "#ffd84a",
        "buttonSolidCheckedActiveBg": "#ffd84a"
      },
      "Switch": {
        "colorPrimary": "#8f6c00",
        "colorPrimaryHover": "#8f6c00"
      },
      "Message": {
        "contentBg": "#ffffff"
      },
      "Notification": {
        "colorBgElevated": "#ffffff"
      }
    }
  },
  "light-paper": {
    "token": {
      "colorPrimary": "#ffe169",
      "colorPrimaryHover": "#ffd84a",
      "colorPrimaryActive": "#ffcf1a",
      "colorPrimaryBg": "#fff0b8",
      "colorPrimaryBgHover": "rgba(0, 0, 0, 0.078)",
      "colorPrimaryBorder": "#ffe169",
      "colorPrimaryBorderHover": "#ffd84a",
      "colorPrimaryText": "#262626",
      "colorPrimaryTextHover": "#262626",
      "colorPrimaryTextActive": "#262626",
      "colorLink": "#262626",
      "colorLinkHover": "#646464",
      "colorLinkActive": "#262626",
      "colorSuccess": "#16732a",
      "colorSuccessBg": "rgba(40, 205, 65, 0.122)",
      "colorWarning": "#7a4f00",
      "colorWarningBg": "rgba(122, 79, 0, 0.078)",
      "colorError": "#a21f18",
      "colorErrorHover": "#861812",
      "colorErrorActive": "#861812",
      "colorErrorBg": "rgba(162, 31, 24, 0.078)",
      "colorInfo": "#5468e0",
      "colorTextBase": "#262626",
      "colorBgBase": "#fffdf5",
      "colorText": "#262626",
      "colorTextSecondary": "#646464",
      "colorTextTertiary": "#696969",
      "colorTextQuaternary": "#8d8d8d",
      "colorTextPlaceholder": "#696969",
      "colorTextDisabled": "#8d8d8d",
      "colorIcon": "#8d8d8d",
      "colorIconHover": "#646464",
      "colorBgLayout": "#fffdf5",
      "colorBgContainer": "#ffffff",
      "colorBgElevated": "#ffffff",
      "colorBgSpotlight": "#333333",
      "colorBgMask": "rgba(0, 0, 0, 0.12)",
      "colorBorder": "rgba(0, 0, 0, 0.078)",
      "colorBorderSecondary": "rgba(0, 0, 0, 0.05)",
      "colorSplit": "rgba(0, 0, 0, 0.05)",
      "colorFill": "rgba(0, 0, 0, 0.078)",
      "colorFillSecondary": "rgba(0, 0, 0, 0.059)",
      "colorFillTertiary": "rgba(0, 0, 0, 0.043)",
      "colorFillQuaternary": "rgba(0, 0, 0, 0.043)",
      "controlItemBgHover": "rgba(0, 0, 0, 0.043)",
      "controlItemBgActive": "#fff0b8",
      "controlItemBgActiveHover": "#fff0b8",
      "colorBgContainerDisabled": "rgba(0, 0, 0, 0.043)",
      "controlOutline": "rgba(38, 38, 38, 0.6)",
      "controlOutlineWidth": 2,
      "lineWidthFocus": 2,
      "fontFamily": "-apple-system, BlinkMacSystemFont, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Segoe UI', sans-serif",
      "fontFamilyCode": "'SF Mono', 'JetBrains Mono', Menlo, Consolas, monospace",
      "fontSize": 14.5,
      "fontSizeSM": 12.5,
      "fontSizeLG": 15.5,
      "fontSizeHeading1": 28,
      "fontSizeHeading2": 24,
      "fontSizeHeading3": 21,
      "fontSizeHeading4": 15.5,
      "fontSizeHeading5": 14.5,
      "lineHeight": 1.6,
      "fontWeightStrong": 600,
      "borderRadius": 14,
      "borderRadiusLG": 20,
      "borderRadiusSM": 13,
      "borderRadiusXS": 9,
      "borderRadiusOuter": 14,
      "controlHeight": 34,
      "controlHeightSM": 30,
      "controlHeightLG": 46,
      "controlHeightXS": 22,
      "motionDurationFast": "0.16s",
      "motionDurationMid": "0.22s",
      "motionDurationSlow": "0.32s",
      "motionEaseOut": "cubic-bezier(0.23, 1, 0.32, 1)",
      "motionEaseInOut": "cubic-bezier(0.32, 0.72, 0, 1)",
      "motionEaseOutBack": "cubic-bezier(0.34, 1.36, 0.64, 1)",
      "boxShadow": "0px 0px 0px 1px rgba(0, 0, 0, 0.05), 0px 8px 20px -6px rgba(0, 0, 0, 0.078), 0px 28px 60px -18px rgba(0, 0, 0, 0.2)",
      "boxShadowSecondary": "0px 0px 0px 1px rgba(0, 0, 0, 0.04), 0px 4px 12px -4px rgba(0, 0, 0, 0.071), 0px 18px 40px -14px rgba(0, 0, 0, 0.141)",
      "boxShadowTertiary": "none",
      "wireframe": false
    },
    "components": {
      "Button": {
        "colorPrimary": "#ffe169",
        "colorPrimaryHover": "#ffd84a",
        "colorPrimaryActive": "#ffcf1a",
        "primaryColor": "#262626",
        "primaryShadow": "0px 0px 0px 1px rgba(0, 0, 0, 0.063)",
        "defaultBg": "rgba(0, 0, 0, 0.059)",
        "defaultColor": "#646464",
        "defaultBorderColor": "transparent",
        "defaultHoverBg": "rgba(0, 0, 0, 0.09)",
        "defaultHoverColor": "#262626",
        "defaultHoverBorderColor": "transparent",
        "defaultActiveBg": "rgba(0, 0, 0, 0.12)",
        "defaultActiveColor": "#262626",
        "defaultActiveBorderColor": "transparent",
        "defaultShadow": "none",
        "textHoverBg": "rgba(0, 0, 0, 0.059)",
        "colorError": "#a21f18",
        "colorErrorHover": "#861812",
        "colorErrorActive": "#861812",
        "dangerColor": "#ffffff",
        "borderRadius": 999,
        "borderRadiusLG": 999,
        "borderRadiusSM": 999,
        "controlHeight": 34,
        "controlHeightSM": 30,
        "controlHeightLG": 46,
        "paddingInline": 16,
        "paddingInlineSM": 12,
        "fontWeight": 500,
        "contentFontSize": 13.5
      },
      "Card": {
        "colorBgContainer": "#ffffff",
        "colorBorderSecondary": "transparent",
        "borderRadiusLG": 20,
        "bodyPadding": 16,
        "headerBg": "transparent",
        "boxShadowTertiary": "0px 0px 0px 1px rgba(0, 0, 0, 0.04), 0px 4px 12px -4px rgba(0, 0, 0, 0.071), 0px 18px 40px -14px rgba(0, 0, 0, 0.141)"
      },
      "Menu": {
        "itemBg": "transparent",
        "subMenuItemBg": "transparent",
        "itemColor": "#646464",
        "itemHoverColor": "#262626",
        "itemHoverBg": "rgba(0, 0, 0, 0.059)",
        "itemActiveBg": "rgba(0, 0, 0, 0.12)",
        "itemSelectedBg": "#fff0b8",
        "itemSelectedColor": "#262626",
        "itemBorderRadius": 14,
        "itemHeight": 38,
        "activeBarBorderWidth": 0,
        "activeBarWidth": 0
      },
      "Segmented": {
        "trackBg": "rgba(0, 0, 0, 0.043)",
        "trackPadding": 4,
        "itemColor": "#646464",
        "itemHoverColor": "#262626",
        "itemHoverBg": "transparent",
        "itemActiveBg": "transparent",
        "itemSelectedBg": "#fff0b8",
        "itemSelectedColor": "#262626",
        "boxShadowTertiary": "none",
        "borderRadius": 999,
        "borderRadiusSM": 999,
        "borderRadiusLG": 999,
        "controlHeight": 32
      },
      "Input": {
        "colorBgContainer": "rgba(0, 0, 0, 0.043)",
        "colorBorder": "transparent",
        "hoverBorderColor": "transparent",
        "activeBorderColor": "transparent",
        "activeShadow": "0 0 0 2px rgba(38, 38, 38, 0.6)",
        "colorTextPlaceholder": "#696969",
        "borderRadius": 999,
        "borderRadiusSM": 999,
        "borderRadiusLG": 999,
        "paddingInline": 16,
        "controlHeightLG": 46
      },
      "Tag": {
        "defaultBg": "rgba(0, 0, 0, 0.043)",
        "defaultColor": "#696969",
        "borderRadiusSM": 999
      },
      "Modal": {
        "contentBg": "#ffffff",
        "headerBg": "#ffffff",
        "footerBg": "transparent",
        "borderRadiusLG": 28,
        "boxShadow": "0px 0px 0px 1px rgba(0, 0, 0, 0.05), 0px 8px 20px -6px rgba(0, 0, 0, 0.078), 0px 28px 60px -18px rgba(0, 0, 0, 0.2)"
      },
      "Drawer": {
        "colorBgElevated": "#ffffff",
        "colorBgMask": "rgba(0, 0, 0, 0.12)"
      },
      "Dropdown": {
        "colorBgElevated": "#ffffff",
        "borderRadiusLG": 22,
        "borderRadiusSM": 14,
        "boxShadowSecondary": "0px 0px 0px 1px rgba(0, 0, 0, 0.05), 0px 8px 20px -6px rgba(0, 0, 0, 0.078), 0px 28px 60px -18px rgba(0, 0, 0, 0.2)",
        "controlItemBgHover": "rgba(0, 0, 0, 0.043)",
        "controlHeight": 38
      },
      "Tooltip": {
        "colorBgSpotlight": "#333333",
        "colorTextLightSolid": "#fafafa",
        "borderRadius": 14
      },
      "Layout": {
        "bodyBg": "#fffdf5",
        "headerBg": "#fffdf5",
        "siderBg": "#fff9e5",
        "lightSiderBg": "#fff9e5"
      },
      "Checkbox": {
        "colorPrimary": "#8f6c00",
        "colorPrimaryHover": "#8f6c00",
        "colorWhite": "#ffffff"
      },
      "Radio": {
        "colorPrimary": "#8f6c00",
        "buttonSolidCheckedBg": "#ffe169",
        "buttonSolidCheckedColor": "#262626",
        "buttonSolidCheckedHoverBg": "#ffd84a",
        "buttonSolidCheckedActiveBg": "#ffd84a"
      },
      "Switch": {
        "colorPrimary": "#8f6c00",
        "colorPrimaryHover": "#8f6c00"
      },
      "Message": {
        "contentBg": "#ffffff"
      },
      "Notification": {
        "colorBgElevated": "#ffffff"
      }
    }
  },
  "light-bright": {
    "token": {
      "colorPrimary": "#ffd83d",
      "colorPrimaryHover": "#ffcf1a",
      "colorPrimaryActive": "#e0b100",
      "colorPrimaryBg": "#ffe57a",
      "colorPrimaryBgHover": "rgba(0, 0, 0, 0.078)",
      "colorPrimaryBorder": "#ffd83d",
      "colorPrimaryBorderHover": "#ffcf1a",
      "colorPrimaryText": "#262626",
      "colorPrimaryTextHover": "#262626",
      "colorPrimaryTextActive": "#262626",
      "colorLink": "#262626",
      "colorLinkHover": "#646464",
      "colorLinkActive": "#262626",
      "colorSuccess": "#16732a",
      "colorSuccessBg": "rgba(40, 205, 65, 0.122)",
      "colorWarning": "#7a4f00",
      "colorWarningBg": "rgba(122, 79, 0, 0.078)",
      "colorError": "#a21f18",
      "colorErrorHover": "#861812",
      "colorErrorActive": "#861812",
      "colorErrorBg": "rgba(162, 31, 24, 0.078)",
      "colorInfo": "#5468e0",
      "colorTextBase": "#262626",
      "colorBgBase": "#ffffff",
      "colorText": "#262626",
      "colorTextSecondary": "#646464",
      "colorTextTertiary": "#696969",
      "colorTextQuaternary": "#8d8d8d",
      "colorTextPlaceholder": "#696969",
      "colorTextDisabled": "#8d8d8d",
      "colorIcon": "#8d8d8d",
      "colorIconHover": "#646464",
      "colorBgLayout": "#ffffff",
      "colorBgContainer": "#ffffff",
      "colorBgElevated": "#ffffff",
      "colorBgSpotlight": "#333333",
      "colorBgMask": "rgba(0, 0, 0, 0.12)",
      "colorBorder": "rgba(0, 0, 0, 0.078)",
      "colorBorderSecondary": "rgba(0, 0, 0, 0.05)",
      "colorSplit": "rgba(0, 0, 0, 0.05)",
      "colorFill": "rgba(0, 0, 0, 0.078)",
      "colorFillSecondary": "rgba(0, 0, 0, 0.059)",
      "colorFillTertiary": "rgba(0, 0, 0, 0.043)",
      "colorFillQuaternary": "rgba(0, 0, 0, 0.043)",
      "controlItemBgHover": "rgba(0, 0, 0, 0.043)",
      "controlItemBgActive": "#ffe57a",
      "controlItemBgActiveHover": "#ffe57a",
      "colorBgContainerDisabled": "rgba(0, 0, 0, 0.043)",
      "controlOutline": "rgba(38, 38, 38, 0.6)",
      "controlOutlineWidth": 2,
      "lineWidthFocus": 2,
      "fontFamily": "-apple-system, BlinkMacSystemFont, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Segoe UI', sans-serif",
      "fontFamilyCode": "'SF Mono', 'JetBrains Mono', Menlo, Consolas, monospace",
      "fontSize": 14.5,
      "fontSizeSM": 12.5,
      "fontSizeLG": 15.5,
      "fontSizeHeading1": 28,
      "fontSizeHeading2": 24,
      "fontSizeHeading3": 21,
      "fontSizeHeading4": 15.5,
      "fontSizeHeading5": 14.5,
      "lineHeight": 1.6,
      "fontWeightStrong": 600,
      "borderRadius": 14,
      "borderRadiusLG": 20,
      "borderRadiusSM": 13,
      "borderRadiusXS": 9,
      "borderRadiusOuter": 14,
      "controlHeight": 34,
      "controlHeightSM": 30,
      "controlHeightLG": 46,
      "controlHeightXS": 22,
      "motionDurationFast": "0.16s",
      "motionDurationMid": "0.22s",
      "motionDurationSlow": "0.32s",
      "motionEaseOut": "cubic-bezier(0.23, 1, 0.32, 1)",
      "motionEaseInOut": "cubic-bezier(0.32, 0.72, 0, 1)",
      "motionEaseOutBack": "cubic-bezier(0.34, 1.36, 0.64, 1)",
      "boxShadow": "0px 0px 0px 1px rgba(0, 0, 0, 0.05), 0px 8px 20px -6px rgba(0, 0, 0, 0.078), 0px 28px 60px -18px rgba(0, 0, 0, 0.2)",
      "boxShadowSecondary": "0px 0px 0px 1px rgba(0, 0, 0, 0.04), 0px 4px 12px -4px rgba(0, 0, 0, 0.071), 0px 18px 40px -14px rgba(0, 0, 0, 0.141)",
      "boxShadowTertiary": "none",
      "wireframe": false
    },
    "components": {
      "Button": {
        "colorPrimary": "#ffd83d",
        "colorPrimaryHover": "#ffcf1a",
        "colorPrimaryActive": "#e0b100",
        "primaryColor": "#262626",
        "primaryShadow": "0px 0px 0px 1px rgba(0, 0, 0, 0.063)",
        "defaultBg": "rgba(0, 0, 0, 0.059)",
        "defaultColor": "#646464",
        "defaultBorderColor": "transparent",
        "defaultHoverBg": "rgba(0, 0, 0, 0.09)",
        "defaultHoverColor": "#262626",
        "defaultHoverBorderColor": "transparent",
        "defaultActiveBg": "rgba(0, 0, 0, 0.12)",
        "defaultActiveColor": "#262626",
        "defaultActiveBorderColor": "transparent",
        "defaultShadow": "none",
        "textHoverBg": "rgba(0, 0, 0, 0.059)",
        "colorError": "#a21f18",
        "colorErrorHover": "#861812",
        "colorErrorActive": "#861812",
        "dangerColor": "#ffffff",
        "borderRadius": 999,
        "borderRadiusLG": 999,
        "borderRadiusSM": 999,
        "controlHeight": 34,
        "controlHeightSM": 30,
        "controlHeightLG": 46,
        "paddingInline": 16,
        "paddingInlineSM": 12,
        "fontWeight": 500,
        "contentFontSize": 13.5
      },
      "Card": {
        "colorBgContainer": "#f5f5f5",
        "colorBorderSecondary": "transparent",
        "borderRadiusLG": 20,
        "bodyPadding": 16,
        "headerBg": "transparent",
        "boxShadowTertiary": "0px 0px 0px 1px rgba(0, 0, 0, 0.04), 0px 4px 12px -4px rgba(0, 0, 0, 0.071), 0px 18px 40px -14px rgba(0, 0, 0, 0.141)"
      },
      "Menu": {
        "itemBg": "transparent",
        "subMenuItemBg": "transparent",
        "itemColor": "#646464",
        "itemHoverColor": "#262626",
        "itemHoverBg": "rgba(0, 0, 0, 0.059)",
        "itemActiveBg": "rgba(0, 0, 0, 0.12)",
        "itemSelectedBg": "#ffe57a",
        "itemSelectedColor": "#262626",
        "itemBorderRadius": 14,
        "itemHeight": 38,
        "activeBarBorderWidth": 0,
        "activeBarWidth": 0
      },
      "Segmented": {
        "trackBg": "rgba(0, 0, 0, 0.043)",
        "trackPadding": 4,
        "itemColor": "#646464",
        "itemHoverColor": "#262626",
        "itemHoverBg": "transparent",
        "itemActiveBg": "transparent",
        "itemSelectedBg": "#ffe57a",
        "itemSelectedColor": "#262626",
        "boxShadowTertiary": "none",
        "borderRadius": 999,
        "borderRadiusSM": 999,
        "borderRadiusLG": 999,
        "controlHeight": 32
      },
      "Input": {
        "colorBgContainer": "rgba(0, 0, 0, 0.043)",
        "colorBorder": "transparent",
        "hoverBorderColor": "transparent",
        "activeBorderColor": "transparent",
        "activeShadow": "0 0 0 2px rgba(38, 38, 38, 0.6)",
        "colorTextPlaceholder": "#696969",
        "borderRadius": 999,
        "borderRadiusSM": 999,
        "borderRadiusLG": 999,
        "paddingInline": 16,
        "controlHeightLG": 46
      },
      "Tag": {
        "defaultBg": "rgba(0, 0, 0, 0.043)",
        "defaultColor": "#696969",
        "borderRadiusSM": 999
      },
      "Modal": {
        "contentBg": "#ffffff",
        "headerBg": "#ffffff",
        "footerBg": "transparent",
        "borderRadiusLG": 28,
        "boxShadow": "0px 0px 0px 1px rgba(0, 0, 0, 0.05), 0px 8px 20px -6px rgba(0, 0, 0, 0.078), 0px 28px 60px -18px rgba(0, 0, 0, 0.2)"
      },
      "Drawer": {
        "colorBgElevated": "#ffffff",
        "colorBgMask": "rgba(0, 0, 0, 0.12)"
      },
      "Dropdown": {
        "colorBgElevated": "#ffffff",
        "borderRadiusLG": 22,
        "borderRadiusSM": 14,
        "boxShadowSecondary": "0px 0px 0px 1px rgba(0, 0, 0, 0.05), 0px 8px 20px -6px rgba(0, 0, 0, 0.078), 0px 28px 60px -18px rgba(0, 0, 0, 0.2)",
        "controlItemBgHover": "rgba(0, 0, 0, 0.043)",
        "controlHeight": 38
      },
      "Tooltip": {
        "colorBgSpotlight": "#333333",
        "colorTextLightSolid": "#fafafa",
        "borderRadius": 14
      },
      "Layout": {
        "bodyBg": "#ffffff",
        "headerBg": "#ffffff",
        "siderBg": "#fff4c7",
        "lightSiderBg": "#fff4c7"
      },
      "Checkbox": {
        "colorPrimary": "#8f6c00",
        "colorPrimaryHover": "#8f6c00",
        "colorWhite": "#ffffff"
      },
      "Radio": {
        "colorPrimary": "#8f6c00",
        "buttonSolidCheckedBg": "#ffd83d",
        "buttonSolidCheckedColor": "#262626",
        "buttonSolidCheckedHoverBg": "#ffcf1a",
        "buttonSolidCheckedActiveBg": "#ffcf1a"
      },
      "Switch": {
        "colorPrimary": "#8f6c00",
        "colorPrimaryHover": "#8f6c00"
      },
      "Message": {
        "contentBg": "#ffffff"
      },
      "Notification": {
        "colorBgElevated": "#ffffff"
      }
    }
  },
  "dark": {
    "token": {
      "colorPrimary": "#f4ece1",
      "colorPrimaryHover": "#ffffff",
      "colorPrimaryActive": "#e8dfd2",
      "colorPrimaryBg": "rgba(255, 241, 224, 0.122)",
      "colorPrimaryBgHover": "rgba(255, 241, 224, 0.122)",
      "colorPrimaryBorder": "#f4ece1",
      "colorPrimaryBorderHover": "#ffffff",
      "colorPrimaryText": "#f7f0e6",
      "colorPrimaryTextHover": "rgba(247, 240, 230, 0.9)",
      "colorPrimaryTextActive": "rgba(247, 240, 230, 0.9)",
      "colorLink": "rgba(247, 240, 230, 0.9)",
      "colorLinkHover": "rgba(247, 240, 230, 0.7)",
      "colorLinkActive": "rgba(247, 240, 230, 0.9)",
      "colorSuccess": "#6dd459",
      "colorSuccessBg": "rgba(109, 212, 89, 0.125)",
      "colorWarning": "#f2b84b",
      "colorWarningBg": "rgba(242, 184, 75, 0.141)",
      "colorError": "#ff9b92",
      "colorErrorHover": "#ffb4ac",
      "colorErrorActive": "#ffb4ac",
      "colorErrorBg": "rgba(255, 138, 128, 0.141)",
      "colorInfo": "#5468e0",
      "colorTextBase": "rgba(247, 240, 230, 0.9)",
      "colorBgBase": "#1e1c1a",
      "colorText": "rgba(247, 240, 230, 0.9)",
      "colorTextSecondary": "rgba(247, 240, 230, 0.7)",
      "colorTextTertiary": "rgba(247, 240, 230, 0.6)",
      "colorTextQuaternary": "rgba(247, 240, 230, 0.6)",
      "colorTextPlaceholder": "rgba(247, 240, 230, 0.6)",
      "colorTextDisabled": "rgba(247, 240, 230, 0.6)",
      "colorIcon": "rgba(247, 240, 230, 0.6)",
      "colorIconHover": "rgba(247, 240, 230, 0.7)",
      "colorBgLayout": "#1e1c1a",
      "colorBgContainer": "#2b2826",
      "colorBgElevated": "#2b2826",
      "colorBgSpotlight": "#f4ece1",
      "colorBgMask": "rgba(0, 0, 0, 0.5)",
      "colorBorder": "rgba(255, 241, 224, 0.122)",
      "colorBorderSecondary": "rgba(255, 241, 224, 0.125)",
      "colorSplit": "rgba(255, 241, 224, 0.125)",
      "colorFill": "rgba(255, 241, 224, 0.122)",
      "colorFillSecondary": "rgba(255, 241, 224, 0.102)",
      "colorFillTertiary": "rgba(255, 241, 224, 0.071)",
      "colorFillQuaternary": "rgba(255, 241, 224, 0.071)",
      "controlItemBgHover": "rgba(255, 241, 224, 0.071)",
      "controlItemBgActive": "rgba(255, 241, 224, 0.122)",
      "controlItemBgActiveHover": "rgba(255, 241, 224, 0.122)",
      "colorBgContainerDisabled": "rgba(255, 241, 224, 0.071)",
      "controlOutline": "rgba(247, 240, 230, 0.6)",
      "controlOutlineWidth": 2,
      "lineWidthFocus": 2,
      "fontFamily": "-apple-system, BlinkMacSystemFont, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Segoe UI', sans-serif",
      "fontFamilyCode": "'SF Mono', 'JetBrains Mono', Menlo, Consolas, monospace",
      "fontSize": 14.5,
      "fontSizeSM": 12.5,
      "fontSizeLG": 15.5,
      "fontSizeHeading1": 28,
      "fontSizeHeading2": 24,
      "fontSizeHeading3": 21,
      "fontSizeHeading4": 15.5,
      "fontSizeHeading5": 14.5,
      "lineHeight": 1.6,
      "fontWeightStrong": 600,
      "borderRadius": 14,
      "borderRadiusLG": 20,
      "borderRadiusSM": 13,
      "borderRadiusXS": 9,
      "borderRadiusOuter": 14,
      "controlHeight": 34,
      "controlHeightSM": 30,
      "controlHeightLG": 46,
      "controlHeightXS": 22,
      "motionDurationFast": "0.16s",
      "motionDurationMid": "0.22s",
      "motionDurationSlow": "0.32s",
      "motionEaseOut": "cubic-bezier(0.23, 1, 0.32, 1)",
      "motionEaseInOut": "cubic-bezier(0.32, 0.72, 0, 1)",
      "motionEaseOutBack": "cubic-bezier(0.34, 1.36, 0.64, 1)",
      "boxShadow": "0px 0px 0px 1px rgba(255, 241, 224, 0.11), 0px 8px 20px -6px rgba(0, 0, 0, 0.5), 0px 22px 48px -12px rgba(0, 0, 0, 0.753)",
      "boxShadowSecondary": "0px 0px 0px 1px rgba(255, 241, 224, 0.11), 0px 2px 4px 0px rgba(0, 0, 0, 0.314), 0px 12px 26px -6px rgba(0, 0, 0, 0.5)",
      "boxShadowTertiary": "0px 0px 0px 1px rgba(255, 241, 224, 0.11)",
      "wireframe": false
    },
    "components": {
      "Button": {
        "colorPrimary": "#f4ece1",
        "colorPrimaryHover": "#ffffff",
        "colorPrimaryActive": "#e8dfd2",
        "primaryColor": "#191715",
        "primaryShadow": "none",
        "defaultBg": "rgba(255, 241, 224, 0.102)",
        "defaultColor": "rgba(247, 240, 230, 0.7)",
        "defaultBorderColor": "transparent",
        "defaultHoverBg": "rgba(255, 241, 224, 0.149)",
        "defaultHoverColor": "rgba(247, 240, 230, 0.9)",
        "defaultHoverBorderColor": "transparent",
        "defaultActiveBg": "rgba(255, 241, 224, 0.2)",
        "defaultActiveColor": "rgba(247, 240, 230, 0.9)",
        "defaultActiveBorderColor": "transparent",
        "defaultShadow": "none",
        "textHoverBg": "rgba(255, 241, 224, 0.102)",
        "colorError": "#ff9b92",
        "colorErrorHover": "#ffb4ac",
        "colorErrorActive": "#ffb4ac",
        "dangerColor": "#191715",
        "borderRadius": 999,
        "borderRadiusLG": 999,
        "borderRadiusSM": 999,
        "controlHeight": 34,
        "controlHeightSM": 30,
        "controlHeightLG": 46,
        "paddingInline": 16,
        "paddingInlineSM": 12,
        "fontWeight": 500,
        "contentFontSize": 13.5
      },
      "Card": {
        "colorBgContainer": "#2b2826",
        "colorBorderSecondary": "transparent",
        "borderRadiusLG": 20,
        "bodyPadding": 16,
        "headerBg": "transparent",
        "boxShadowTertiary": "0px 0px 0px 1px rgba(255, 241, 224, 0.11), 0px 2px 4px 0px rgba(0, 0, 0, 0.314), 0px 12px 26px -6px rgba(0, 0, 0, 0.5)"
      },
      "Menu": {
        "itemBg": "transparent",
        "subMenuItemBg": "transparent",
        "itemColor": "rgba(247, 240, 230, 0.7)",
        "itemHoverColor": "rgba(247, 240, 230, 0.9)",
        "itemHoverBg": "rgba(255, 241, 224, 0.102)",
        "itemActiveBg": "rgba(255, 241, 224, 0.2)",
        "itemSelectedBg": "rgba(255, 241, 224, 0.122)",
        "itemSelectedColor": "#f7f0e6",
        "itemBorderRadius": 14,
        "itemHeight": 38,
        "activeBarBorderWidth": 0,
        "activeBarWidth": 0
      },
      "Segmented": {
        "trackBg": "rgba(255, 241, 224, 0.071)",
        "trackPadding": 4,
        "itemColor": "rgba(247, 240, 230, 0.7)",
        "itemHoverColor": "rgba(247, 240, 230, 0.9)",
        "itemHoverBg": "transparent",
        "itemActiveBg": "transparent",
        "itemSelectedBg": "rgba(255, 241, 224, 0.149)",
        "itemSelectedColor": "rgba(247, 240, 230, 0.9)",
        "boxShadowTertiary": "0px 0px 0px 1px rgba(255, 241, 224, 0.11)",
        "borderRadius": 999,
        "borderRadiusSM": 999,
        "borderRadiusLG": 999,
        "controlHeight": 32
      },
      "Input": {
        "colorBgContainer": "rgba(255, 241, 224, 0.071)",
        "colorBorder": "transparent",
        "hoverBorderColor": "transparent",
        "activeBorderColor": "transparent",
        "activeShadow": "0 0 0 2px rgba(247, 240, 230, 0.6)",
        "colorTextPlaceholder": "rgba(247, 240, 230, 0.6)",
        "borderRadius": 999,
        "borderRadiusSM": 999,
        "borderRadiusLG": 999,
        "paddingInline": 16,
        "controlHeightLG": 46
      },
      "Tag": {
        "defaultBg": "rgba(255, 241, 224, 0.071)",
        "defaultColor": "rgba(247, 240, 230, 0.6)",
        "borderRadiusSM": 999
      },
      "Modal": {
        "contentBg": "#2b2826",
        "headerBg": "#2b2826",
        "footerBg": "transparent",
        "borderRadiusLG": 28,
        "boxShadow": "0px 0px 0px 1px rgba(255, 241, 224, 0.11), 0px 8px 20px -6px rgba(0, 0, 0, 0.5), 0px 22px 48px -12px rgba(0, 0, 0, 0.753)"
      },
      "Drawer": {
        "colorBgElevated": "#2b2826",
        "colorBgMask": "rgba(0, 0, 0, 0.5)"
      },
      "Dropdown": {
        "colorBgElevated": "#2b2826",
        "borderRadiusLG": 22,
        "borderRadiusSM": 14,
        "boxShadowSecondary": "0px 0px 0px 1px rgba(255, 241, 224, 0.11), 0px 8px 20px -6px rgba(0, 0, 0, 0.5), 0px 22px 48px -12px rgba(0, 0, 0, 0.753)",
        "controlItemBgHover": "rgba(255, 241, 224, 0.071)",
        "controlHeight": 38
      },
      "Tooltip": {
        "colorBgSpotlight": "#f4ece1",
        "colorTextLightSolid": "#191715",
        "borderRadius": 14
      },
      "Layout": {
        "bodyBg": "#1e1c1a",
        "headerBg": "#1e1c1a",
        "siderBg": "#191715",
        "lightSiderBg": "#191715"
      },
      "Checkbox": {
        "colorPrimary": "#f2c94c",
        "colorPrimaryHover": "#f2c94c",
        "colorWhite": "#1c1712"
      },
      "Radio": {
        "colorPrimary": "#f2c94c",
        "buttonSolidCheckedBg": "#f4ece1",
        "buttonSolidCheckedColor": "#191715",
        "buttonSolidCheckedHoverBg": "#ffffff",
        "buttonSolidCheckedActiveBg": "#ffffff"
      },
      "Switch": {
        "colorPrimary": "#f2c94c",
        "colorPrimaryHover": "#f2c94c"
      },
      "Message": {
        "contentBg": "#2b2826"
      },
      "Notification": {
        "colorBgElevated": "#2b2826"
      }
    }
  }
}

export function isDarkAppearance(appearance) {
  return appearance === 'dark'
}

export function getLingzhiAntdTheme(appearance = "light-ink") {
  const theme = lingzhiAntdThemes[appearance]
  if (!theme) throw new Error(`没有这种外观：${appearance}（可选：${appearances.join(' / ')}）`)
  return structuredClone(theme)
}
